module.exports = __webpack_public_path__ + "static/media/lowerleg.57f44fd7.jpg";